// 浏览器和桌面端使用同一份用户提示策略；服务端仍会再次校验，不能依赖前端绕过规则。

export const ACCOUNT_USERNAME_MIN_LENGTH = 4;
export const ACCOUNT_USERNAME_MAX_LENGTH = 128;
export const ACCOUNT_PASSWORD_MIN_LENGTH = 10;
export const ACCOUNT_PASSWORD_MAX_LENGTH = 128;

const ACCOUNT_USERNAME_PATTERN = /^[\p{L}\p{N}](?:[\p{L}\p{N}._+@-]*[\p{L}\p{N}])?$/u;
const CONTROL_CHARACTER_PATTERN = /[\u0000-\u001F\u007F-\u009F]/u;
const COMMON_PASSWORDS = new Set([
  '1234567890',
  '0987654321',
  'password1',
  'password123',
  'passw0rd123',
  'qwerty1234',
  'qwertyuiop',
  'admin12345',
  'welcome123',
  'letmein123',
  'changeme123',
  'abc1234567',
  'iloveyou123',
  'secret1234',
  '1111111111',
  '0000000000',
]);

function codePointLength(value: string): number {
  return Array.from(value).length;
}

export function validateAccountUsername(value: unknown, mode: 'login' | 'register' = 'register'): string | null {
  if (typeof value !== 'string') return '账号名格式不正确';
  const username = value.trim();
  const length = codePointLength(username);
  const minLength = mode === 'register' ? ACCOUNT_USERNAME_MIN_LENGTH : 1;
  if (length < minLength || length > ACCOUNT_USERNAME_MAX_LENGTH) {
    return mode === 'register'
      ? `账号名需为 ${ACCOUNT_USERNAME_MIN_LENGTH}–${ACCOUNT_USERNAME_MAX_LENGTH} 位`
      : '账号名或密码长度无效';
  }
  if (mode === 'register' && (!ACCOUNT_USERNAME_PATTERN.test(username) || CONTROL_CHARACTER_PATTERN.test(username))) {
    return '账号名只能包含字母、数字、中文及 . _ - + @，且不能以符号开头或结尾';
  }
  return null;
}

export function validateAccountPassword(
  value: unknown,
  username = '',
  mode: 'login' | 'register' = 'register',
): string | null {
  if (typeof value !== 'string') return mode === 'register' ? '请设置账号密码' : '账号名或密码长度无效';
  const length = codePointLength(value);
  const minLength = mode === 'register' ? ACCOUNT_PASSWORD_MIN_LENGTH : 1;
  if (length < minLength || length > ACCOUNT_PASSWORD_MAX_LENGTH) {
    return mode === 'register'
      ? `密码需为 ${ACCOUNT_PASSWORD_MIN_LENGTH}–${ACCOUNT_PASSWORD_MAX_LENGTH} 位`
      : '账号名或密码长度无效';
  }
  if (CONTROL_CHARACTER_PATTERN.test(value)) {
    return mode === 'register' ? '密码不能包含不可见控制字符' : '账号名或密码长度无效';
  }
  if (mode === 'login') return null;

  const normalized = value.toLowerCase().replace(/\s+/gu, '');
  if (COMMON_PASSWORDS.has(normalized)) return '这个密码过于常见，请换一个更独特的密码';
  if (username && normalized === username.toLowerCase()) return '密码不能与账号名相同';
  if (/^(.)\1+$/su.test(value)) return '密码不能由同一个字符重复组成';

  const characterClasses = [
    /\p{L}/u.test(value),
    /\p{N}/u.test(value),
    /[^\p{L}\p{N}\s]/u.test(value),
  ].filter(Boolean).length;
  if (characterClasses < 2) return '密码至少包含字母、数字或符号中的两类';
  return null;
}
